import { Component, Input } from '@angular/core';

@Component({
  selector: 'status-point',
  templateUrl: './status-point.component.html',
  styleUrls: ['./status-point.component.scss']
})
export class StatusPointComponent {

  @Input() background: string;
}
